export class CategoriaCnh {
  ativo: boolean;
  categoria: string;
  id: number;
  veiculo: boolean;
  moto: boolean;
  peso: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/cnh/categorias-cnh/shared/categoria-cnh.model.ts
 **/